import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import ContactCard from './pages/ContactCard'; // ✅ Add this line

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/jatin-contact" element={<ContactCard />} /> {/* ✅ Add this line */}
      </Routes>
    </Router>
  );
};

export default App;
